import { Component, OnInit } from '@angular/core';

@Component ({
  selector: 'app-home-control-cliente',
  templateUrl: './logisticaES.component.html',
})

export class LogisticaESComponent implements OnInit{

  ngOnInit(): void {
  }
}



// WEBPACK FOOTER //
// /media/julen/a87ddcee-c364-426b-b833-77926fe0cdef/julen/Ironchip/Proyectos/dative/dative-FMOT/FMOT/src/app/logisticaES/logisticaES.component.ts